import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { ModalDump } from "./ModalDump"

const FooterBotones = () => {
  const handleRefresh = () => window.location.reload(),
    { t } = useTranslation()
  return (
    <>
      <div className="d-flex row-flex justify-content-center w-100">
        <Link to="/">
          <button type="button" className="btn btn-secondary me-2">
            {t(`ui.btns.back_to_home`)}
          </button>
        </Link>

        <button
          type="button"
          className="btn btn-primary"
          onClick={() => handleRefresh()}
        >
          {t(`ui.btns.try_again`)}
        </button>
      </div>
    </>
  )
}

export const ModalError = ({ show, res }) => {
  const { t } = useTranslation()
  return (
    <>
      <ModalDump
        id="err-res-modal"
        show={show}
        res={res}
        title={t(`modals.error.title`)}
        footer={<FooterBotones />}
      />
    </>
  )
}
